import React from "react";
import { useForm } from "../../../hooks/useForm";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, TextField, makeStyles } from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import { setActiveStep } from "../../../actions/empadronamiento/Empadronamiento";
import { STEPPER_EMPADRONAMIENTO, TIPO_EMPADRONAMIENTO } from "../../../utils/constants";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { EmpadronamientoDiagnosticosForm } from "./EmpadronamientoDiagnosticosForm";
import { postSolicitud, setSolicitud } from "../../../actions/empadronamiento/Empadronamiento";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { EMPADRONAMIENTO_MENU_PERMISOS } from "../../../utils/permisos";

const useStyles = makeStyles((theme) => ({
  texto: {
    padding: 2,
    marginLeft: 30,
    marginTop: 4,
    width: '89%',
  }
}));

export const EmpadronamientoDetalleSolicitudInformation = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { solicitudSeleccionada,idTipoEmpadronamiento } = useSelector((state) => state.empadronamiento);

  const { permisos: permisosUser } = useSelector((state) => state.auth);

  const [
    formValues,
    ,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    ,
  ] = useForm(
    solicitudSeleccionada
  );

  /*
  CELIAQUIA: 1,
  DIABETES: 2,
  DISCAPACIDAD: 3,
  HIPERTENSION: 4,
  HIV: 5,
  LECHES_MATERNIZADAS: 6,
  MEDICACION_ALTO_COSTO: 7,
  MEDICACION_CRONICA_100: 8,
  MEDICACION_CRONICA_70: 9,
  MEDICACION_CRONICA_40: 10,
  ONCOLOGIA: 11
  */

  const fechaDeHoy = new Date();
  let propuestaFechaFin = new Date();

  switch (idTipoEmpadronamiento) {
    case TIPO_EMPADRONAMIENTO.CELIAQUIA:
      propuestaFechaFin = null; // No tenemos info
      break;
    case TIPO_EMPADRONAMIENTO.DIABETES:
      propuestaFechaFin.setMonth(fechaDeHoy.getMonth() + 6);
      break;
    case TIPO_EMPADRONAMIENTO.DISCAPACIDAD:
      propuestaFechaFin.setMonth(fechaDeHoy.getMonth() + 12);
      break;
    case TIPO_EMPADRONAMIENTO.HIPERTENSION:
      propuestaFechaFin = null; // No tenemos info
      break;
    case TIPO_EMPADRONAMIENTO.HIV:
      propuestaFechaFin = null; // Va por otro circuito
      break;
    case TIPO_EMPADRONAMIENTO.LECHES_MATERNIZADAS:
      propuestaFechaFin = null; // No tenemos info
      break;
    case TIPO_EMPADRONAMIENTO.MEDICACION_ALTO_COSTO:
      propuestaFechaFin.setMonth(fechaDeHoy.getMonth() + 6);
      break;
    case TIPO_EMPADRONAMIENTO.MEDICACION_CRONICA_100:
      propuestaFechaFin = null; // No tenemos info
      break;
    case TIPO_EMPADRONAMIENTO.MEDICACION_CRONICA_70:
      propuestaFechaFin = null; // No tenemos info
      break;
    case TIPO_EMPADRONAMIENTO.MEDICACION_CRONICA_40:
      propuestaFechaFin.setMonth(fechaDeHoy.getMonth() + 12);
      break;
    case TIPO_EMPADRONAMIENTO.ONCOLOGIA:
      propuestaFechaFin.setMonth(fechaDeHoy.getMonth() + 6);
      break;
    default:
      propuestaFechaFin = null;
  }

  const {
    fechaInicio = fechaDeHoy,
    fechaFin = propuestaFechaFin,
    observaciones = null
  } = formValues;

  const submitHandler = () => {
    const data = {
      ...solicitudSeleccionada,
      diagnosticos: formValues.diagnosticos,
      fechaInicio,
      fechaFin,
      observaciones,
      editandoDiagnosticos: true,
      editandoPrograma: false,
      esAuditorDisca: validarSoloUnPermiso(
        permisosUser,
        EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
      )
    };
    dispatch(postSolicitud(data, null, null, false, setActiveStep, STEPPER_EMPADRONAMIENTO.DOCUMENTACION));
    dispatch(setSolicitud(data));
    //dispatch(setActiveStep(STEPPER_EMPADRONAMIENTO.DOCUMENTACION));
  };

  return (
    <React.Fragment>
      <ValidatorForm onSubmit={submitHandler}>
        <Grid
          container
          spacing={2}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item xs={6} md={4} >
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
              <ValidatedDatePicker
                margin="normal"
                id="dialogFecIni"
                label="Fecha Inicio"
                format="dd/MM/yyyy"
                okLabel="Aceptar"
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                disabled={false}
                value={fechaInicio}
                onChange={(date) => {
                  setearValor("fechaInicio", date);
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                validators={["required"]}
                errorMessages={["Este campo es requerido"]}
                minDate={new Date()}
                minDateMessage={`La fecha no puede ser anterior a la fecha actual`}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item xs={6} md={4} >
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
              <ValidatedDatePicker
                margin="normal"
                id="dialogFecFin"
                label="Fecha Fin"
                format="dd/MM/yyyy"
                okLabel="Aceptar"
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                disabled={false}
                value={fechaFin}
                onChange={(date) => {
                  setearValor("fechaFin", date);
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                /*validators={["required"]}
                errorMessages={["Este campo es requerido"]}*/
                minDate={fechaInicio}
                minDateMessage={`La fecha de fin no puede ser anterior a la fecha de inicio`}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item xs={12} style={{ marginTop: -15 }}>
            <EmpadronamientoDiagnosticosForm
              formValues={formValues}
              setearValor={setearValor}
              idSolicitud={solicitudSeleccionada.idSolicitud}
            />
          </Grid>
          <Grid item xs={12} md={12} >
            <TextField
              className={classes.texto}
              name="detalle"
              value={observaciones}
              label="Observaciones"
              //fullWidth
              multiline
              rows={2}
              rowsMax={8}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => {
                setearValor("observaciones", e.target.value);
              }}
            />
          </Grid>
        </Grid>

        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{ marginRight: "3rem" }}
            onClick={() => {
            dispatch(setActiveStep(STEPPER_EMPADRONAMIENTO.DATOS_TITULAR));}}
          >
            Anterior
          </Button>
          <Button variant="contained" color="primary" type="submit">
            Siguiente
          </Button>
        </div>
      </ValidatorForm>
    </React.Fragment>
  );
};
